// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"5eadc5fe","418":"8dd49725","881":"5f57ce80","963":"d719b153"}[chunkId] + ".chunk.js";
};